import axios from 'axios'
import jsSHA from 'jssha'
import wx from 'weixin-js-sdk'
export default {
  wxshare: function(url, tit, imgUrl, content) {
    axios
      .get(
        'http://sjtupyhs.netclass.cn/api/wxsign?time=' + new Date().getTime()
      )
      // .get('http://sev.netban.cn/api/wx/ticket?time=' + new Date().getTime())
      .then(function(data) {
        // let res = eval('(' + data.data + ')')
        let res = data.data.data

        let appId = res.appId
        let ticket = res.ticket
        var e = location.href.split('#')[0]
        // e = e.split('http://')[1]
        var d = Date.now()
        var f = 'netbanview'
        var g =
          'jsapi_ticket=' +
          ticket +
          '&noncestr=' +
          f +
          '&timestamp=' +
          d +
          '&url=' +
          e
        var h = new jsSHA('SHA-1', 'TEXT')
        h.update(g)
        var i = h.getHash('HEX')
        wx.config({
          debug: false, //生产环境需要关闭debug模式
          appId: appId, //appId通过微信服务号后台查看
          timestamp: d, //生成签名的时间戳
          nonceStr: f, //生成签名的随机字符串
          signature: i, //签名
          jsApiList: [
            //需要调用的JS接口列表
            'onMenuShareTimeline', //分享给好友
            'onMenuShareAppMessage', //分享到朋友圈
            // 'showMenuItems',
            // 'hideMenuItems',
          ],
        })
      })

    wx.ready(function() {
      // wx.checkJsApi({
      //   jsApiList: ['showMenuItems'],
      //   success: function (res) {
      //     wx.showMenuItems({
      //       menuList: [
      //         'menuItem:share:appMessage', //发送给朋友
      //         'menuItem:share:timeline', //分享到朋友圈
      //       ],
      //     })
      //   },
      // })

      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: tit, // 分享标题
        desc: content, //分享描述
        link: url, // 分享链接
        imgUrl: imgUrl, // 分享图标
      })
      //分享给朋友
      wx.onMenuShareAppMessage({
        title: tit, // 分享标题
        desc: content, // 分享描述
        link: url, // 分享链接
        imgUrl: imgUrl, // 分享图标
        dataUrl: '',
        success: function() {},
        cancel: function() {
          // 用户取消分享后执行的回调函数
        },
      })
    })
  },
}
